import { Result } from "@praha/byethrow"
import { createServerFn } from "@tanstack/react-start"
import { getPrivacyPolicy as getPrivacyPolicyService } from "@apps/gwservice/privacy-policy"

export const getPrivacyPolicy = createServerFn({
  method: "GET",
})
  .handler(() => Result.try({
    try: () => getPrivacyPolicyService(),
    catch: () => "unexpected server error",
  }))
